import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DividerModule } from 'primeng/divider';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from "primeng/card";
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule } from 'primeng/accordion';

import { ProcessingInformationComponent } from './components/processing-information/processing-information.component';
import { UpdateSubTaskDetailsComponent } from './components/update-sub-task-details/update-sub-task-details.component';
import { GreenCardI140RoutingModule } from './gci140-routing.module';
import { I140TimelineComponent } from './components/i140-timeline/i140-timeline.component';
import { MainContainerComponent } from './components/main-container/main-container.component';
import { JobDescriptionComponent } from './components/job-description/job-description.component';
import { I140SubheaderComponent } from './components/i140-subheader/i140-subheader.component';
import { StatusUpdateComponent } from './components/status-update/status-update.component';
import { AddDutyComponent, JobDutiesComponent } from './components/job-duties/job-duties.component';
import { StoreModule } from '@ngrx/store';
import * as fromStore from './store';
import { EffectsModule } from '@ngrx/effects';
import { SubTaskDetailsEffects } from './store/effects/sub-task-details.effects';
import { BeneficiaryPersonalDetailsComponent } from './components/beneficiary-personal-details/beneficiary-personal-details.component';
import { EducationDetailsComponent } from './components/education-details/education-details.component';
import { WorkExperienceDetailsComponent } from './components/work-experience-details/work-experience-details.component';
// import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
// import 'froala-editor/js/plugins.pkgd.min.js';
import { DeleteDialogComponent } from './components/delete-dialog/delete-dialog.component';
import { StepStatusUpdateEffects } from './store/effects/step-status-update.effects';
import { DependentDetailsComponent } from './components/dependent-details/dependent-details.component';
import { PetitionerDetailsComponent } from './components/petitioner-details/petitioner-details.component';
import { GetReceiptsComponent } from './components/get-receipts/get-receipts.component';
import { SubmitPetitionComponent } from './components/submit-petition/submit-petition.component';
import { PrintPetitionComponent } from './components/print-petition/print-petition.component';
import { UscisContentComponent } from './components/uscis-content/uscis-content.component';
import { MailingAddressComponent } from './components/mailing-address/mailing-address.component';
import { StepStatusUpdatePayload } from './utility/services/stepStatusUpdate.service';
import { PlaceHolderDirective } from './components/uscis-place-holder.directive';
import { NoteDialogComponent } from './components/note-dialog/note-dialog.component';
import { FeeCalculationComponent } from './components/fee-calculation/fee-calculation.component';
import { GenerateFormsComponent } from './components/generate-forms/generate-forms.component';
import { InputMaskModule } from 'primeng/inputmask';
import { ReviewI140PetitionComponent } from './components/review-i140-petition/review-i140-petition.component';
import { ReviewCommentComponent } from './components/review-comment/review-comment.component';
import { LetterGenerationComponent } from './components/letter-generation/letter-generation.component';
import { CoverLetterComponent } from './components/cover-letter/cover-letter.component';
import { SupportLetterComponent } from './components/support-letter/support-letter.component';
import { OrganizeDocumentsComponent } from './components/organize-documents/organize-documents.component';
import { LetterTemplateComponent } from './components/letter-template/letter-template.component';
import { LetterPreviewComponent } from './components/letter-preview/letter-preview.component';
import { PdfViewComponent } from './components/pdf-view/pdf-view.component';
import { CreateTemplateComponent } from './components/create-template/create-template.component';
import { I140FileUploadComponent } from './components/i140-file-upload/i140-file-upload.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { LetterGenerationEntryComponent } from './components/letter-generation-entry/letter-generation-entry.component';
import { PaginatorModule } from 'primeng/paginator';
import { TreeModule } from 'primeng/tree';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InplaceModule } from 'primeng/inplace';
import { FileUploadModule } from 'primeng/fileupload';
import { NgxPermissionsModule } from 'ngx-permissions';
import { BeneficiaryDocumentsComponent } from './components/beneficiary-documents/beneficiary-documents.component';
import { UpdateDecisionComponent } from './components/update-decision/update-decision.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SendNotificationComponent } from './components/send-notification/send-notification.component';
import { I140DateFormatPipe } from './utility/services/dateFormat.pipe';
import { InputNumberModule } from 'primeng/inputnumber';
import { TaskNotesLibModule } from 'task-notes-lib';
import { PrimengLibraryModule } from 'primeng-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TaskAllocationModule } from '../task-allocation/task-allocation.module';
import { HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import { DocumentChecklistLibraryModule } from 'document-checklist-library';
import { EditorModule } from '@progress/kendo-angular-editor';
import { CustomKendoModule } from '../custom-kendo/custom-kendo.module';
import { InCareOfNameModule } from 'in-care-of-name';
import { LockUnlockStepsLibraryModule } from 'lock-unlock-steps-library';
import { ExternalLinksModule } from 'external-links';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { OverrideRadioButtonLibraryModule } from 'override-radio-button-library';
import { OverideUploadFormsLibraryModule } from 'overide-upload-forms-library';
//import { EditCompleteEducationDetailLibraryModule } from 'projects/edit-complete-education-detail-library/src/lib/edit-complete-education-detail-library.module';
//import { EditWorkExperienceDetailsComponent } from './components/edit-work-experience-details/edit-work-experience-details.component';
import {MatTabsModule} from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FileUploadLibraryModule } from 'file-upload-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
//import { ImmigrantEditWorkExperienceDetailsModule } from 'immigrant-edit-work-experience-details';
import { SharedModule } from '../shared/shared.module';
import { I140ReviewPetitonNewComponent } from './components/i140-review-petiton-new/i140-review-petiton-new.component';
import { DocumentChecklistNewLibraryModule } from 'document-checklist-new-library';
import { BeneficiaryPersonalDetailsLibraryModule } from 'projects/beneficiary-personal-details-library/src/public-api';
import { GenericBeneficiaryPersonalDetailsLibraryModule } from 'generic-beneficiary-personal-details-library';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ToastModule } from 'primeng/toast';
import { DateFormatModule } from 'date-format';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileDownloadLibraryModule } from 'file-download-library';
import { MatSelectModule } from '@angular/material/select';
import { EditorLibraryModule } from 'editor-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { GenericBeneficiaryWorkExperienceModule } from 'generic-beneficiary-work-experience';
import { GenericBeneficiaryEducationModule } from 'generic-beneficiary-education';


@NgModule({
  declarations: [
    ProcessingInformationComponent,
    UpdateSubTaskDetailsComponent,
    I140SubheaderComponent,
    I140TimelineComponent,
    MainContainerComponent,
    I140SubheaderComponent,
    StatusUpdateComponent,
    JobDescriptionComponent,
    JobDutiesComponent,
    AddDutyComponent,
    BeneficiaryPersonalDetailsComponent,
    EducationDetailsComponent,
    WorkExperienceDetailsComponent,
    DeleteDialogComponent,
    DependentDetailsComponent,
    PetitionerDetailsComponent,
    GetReceiptsComponent,
    SubmitPetitionComponent,
    PrintPetitionComponent,
    UscisContentComponent,
    MailingAddressComponent,
    NoteDialogComponent,
    FeeCalculationComponent,
    GenerateFormsComponent,
    ReviewI140PetitionComponent,
    ReviewCommentComponent,
    LetterGenerationComponent,
    CoverLetterComponent,
    SupportLetterComponent,
    OrganizeDocumentsComponent,
    LetterTemplateComponent,
    LetterPreviewComponent,
    PdfViewComponent,
    CreateTemplateComponent,
    LetterGenerationEntryComponent,
    PlaceHolderDirective,
    I140FileUploadComponent,
    BeneficiaryDocumentsComponent,
    UpdateDecisionComponent,
    SendNotificationComponent,
    I140DateFormatPipe,
    I140ReviewPetitonNewComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    FormsModule,
    DividerModule,
    ButtonModule,
    ChipsModule,
    CheckboxModule,
    ToggleButtonModule,
    InputSwitchModule,
    RadioButtonModule,
    OverlayPanelModule,
    TimelineModule,
    CardModule,    
    MatExpansionModule,
    MatCheckboxModule,
    MatTableModule,
    MatDividerModule,
    MatRadioModule,
    MatInputModule,
    MatSlideToggleModule,
    MatCardModule,    
    MatDatepickerModule,
    MatMomentDateModule,
    MatChipsModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,   
    MatStepperModule,
    MatButtonToggleModule,
    InputMaskModule,
    PaginatorModule,
    DynamicDialogModule,
    InplaceModule,
    TooltipModule,
    TableModule,
    MatTabsModule,
    FileUploadModule,
    FileUploadLibraryModule,    
    FileUploadDeafultLibraryModule,
    NgxExtendedPdfViewerModule,
    PanelModule,
    CalendarModule,
    AccordionModule,
    TreeModule,
    ConfirmDialogModule,
    PdfViewerModule,
    NgxPermissionsModule,
    InputNumberModule,
    GreenCardI140RoutingModule,
    AssigningTaskLibraryModule,
    TaskAllocationModule,
    // FroalaEditorModule.forRoot(),
    // FroalaViewModule.forRoot(),
    StoreModule.forFeature(fromStore.storeFeatureKey, fromStore.reducers, { metaReducers: fromStore.metaReducers }),
    EffectsModule.forFeature([SubTaskDetailsEffects, StepStatusUpdateEffects]),
    TaskNotesLibModule,
    PrimengLibraryModule,
    NgbTooltipModule,
    DocumentChecklistLibraryModule,
    DocumentChecklistNewLibraryModule,
    HelpVideoOverlayLibraryModule,
    EditorModule,
    CustomKendoModule,
    InCareOfNameModule,
    ExternalLinksModule,
    MaximizeDialogLibraryModule,
    OverrideRadioButtonLibraryModule,
    OverideUploadFormsLibraryModule,
    LockUnlockStepsLibraryModule,
    ExternalLinksModule,   
    MaximizeDialogLibraryModule,
    CustomQuestionnaireModule,
    // EditCompletePersonalDetailLibraryModule,
    // Gci140EditPersonalDetailLibraryModule,
    // EditPersonalDetailsModule,
    // SimplePersonalDetailLibraryModule,
    BeneficiaryPersonalDetailsLibraryModule,
    GenericBeneficiaryPersonalDetailsLibraryModule,
    ConfirmPopupModule,
    ToastModule,
    StepStatusUpdateComponentLibraryModule,
    DateFormatModule,
    LastUpdateLibraryModule,
    ConfirmPopupModule,
    EditorLibraryModule,
    MatSelectModule,
    FileDownloadLibraryModule,
    MatTooltipModule,
    GenericBeneficiaryWorkExperienceModule,
    GenericBeneficiaryEducationModule
  ],
  exports: [I140TimelineComponent],
  bootstrap: [I140TimelineComponent],
  providers: [StepStatusUpdatePayload, I140DateFormatPipe]
})
export class GreenCardI140Module { }
